import { render, staticRenderFns } from "./EditVacation.vue?vue&type=template&id=f022bfba"
import script from "./EditVacation.vue?vue&type=script&lang=js"
export * from "./EditVacation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports